export const fetchAddress = zipCode => ({
  type: 'FETCH_ADDRESS',
  payload: {
    client: 'cloudloyalty',
    request: {
      method: 'get',
      url: `/v1/addresses/${zipCode}`
    }
  }
})

export const setAddress = address => ({
  type: 'SET_ADDRESS',
  address
})

const cleanError = () => ({ type: 'CLEAN_ERROR_ADDRESS' })

export default {
  fetchAddress,
  cleanError,
  setAddress
}



// WEBPACK FOOTER //
// ./src/features/Address/actions.js